import React, { useEffect, useState } from "react";
import FirstSlide from "../Components/FirstSlide";
import ServicesCard from "../Components/ServicesCard";
import Carousel from "../Components/Carousel";
import AboutUs from "../Components/AboutUs";
import WhyUs from "../Components/WhyUs";
import {
  Box,
  Container,
  useMediaQuery,
  Typography,
  Stack,
} from "@mui/material";
import ContactUs from "../Components/ContactUs";
import MessageForm from "../Components/MessageForm";
import pic from "../Media/Mask Group 1.png";
import background from "../Media/Untitled-1.png";
import db from "../DbFile.json";
import { useTranslation } from "react-i18next";
import OurPlog from "../Components/OurPlog";
import OurGoal from "../Components/OurGoal";
import c1 from "../Media/our-goal.png";
import uni from "../Media/UNICEF-logo.png";

export default function MainPage({ setTheState }) {
  const matches = useMediaQuery("(min-width:600px)");
  const [el, setEl] = useState(db.first_array);
  const { t } = useTranslation();
  useEffect(() => {
    setTheState(true);
  }, []);
  return (
    <div>
      <FirstSlide />
      <ServicesCard el={el} />
      <Carousel />
      <AboutUs
        txt={
          "Mashawiri for safe transportation works on providing easy rides for users and generate extra income for the providers of this service. We are a digital company that aspires to share its ambition with people who want to take safer roads and secure a better life by connecting reality & the digital world to facilitate transportation through one click,anywhere, over its dynamic and easy-to-use application."
        }
        caption={"About Us"}
        pic={pic}
      />
      <OurGoal
        caption={"Our Goal"}
        im={c1}
        btn={"Book your ride"}
        txt={
          "Our purpose is to help employees, worker sand students move from one point to another safely, comfortably,and quickly by providing them excellent service at a reasonable cost in addition to assist our driver partners with earning the right extra income"
        }
      />
      <Container sx={{ marginBottom: "100px" }}>
        <Typography
          sx={{ fontSize: "30px", fontWeight: "bold", color: "#1D2877" }}
        >
          {t("Contracted Companies")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "100px",
          }}
        >
          <img alt="img262" src={uni} style={{ width: "300px" }} />
        </Box>
      </Container>
      <WhyUs />
      <OurPlog />
      <Container>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "100px",
          }}
        >
          <ContactUs />
          <MessageForm matches={matches} />
        </Box>
      </Container>
    </div>
  );
}
